function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.5 30.4048L58.5172 11.597L57.5343 10.1572C56.7656 9.03104 55.0139 9.43881 54.8216 10.7886L51.686 32.7918C51.4411 34.5102 48.9561 34.4993 48.7263 32.7788L44.7093 2.70358C44.4915 1.07261 42.1824 0.940565 41.78 2.53608L37.9281 17.8113C37.5838 19.1768 35.7145 19.3511 35.1236 18.073L28.7646 4.31876C28.2309 3.16432 26.5907 3.16234 26.0542 4.31549L22.6663 11.597L18.4492 19.5353C17.8999 20.5694 16.4284 20.5981 15.839 19.5862L9.36311 8.46643C8.90572 7.68104 7.85886 7.48266 7.14582 8.04624L1.34533 12.631",
  stroke: "#FF5B5B",
  strokeWidth: 1.98625
});

function SvgGraphDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 36,
    viewBox: "0 0 72 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphDown);
export default __webpack_public_path__ + "static/media/graphDown.9763c26f3f9e00cbc65a6e43be8fa118.svg";
export { ForwardRef as ReactComponent };